/**
 * PrepNotes — append-only progress log for a single PREPARATION REQUEST.
 *
 * The prep-side peer of FileNotes: a thin adapter over the shared <NotesLog>
 * engine, wired to the preparation-request notes store (prepNotesApi). This is
 * the notes surface §28.7 left deferred; it carries the §31 acknowledgement
 * model. The acknowledger role pair for prep notes is
 * {Adviser, New Business Assistant} (enforced in prepNotesApi).
 *
 * This is distinct from the prep's one-time `written_instructions` field (the
 * Adviser's fixed brief) — this log is the ongoing back-and-forth between the
 * Adviser and the New Business Assistant.
 */

import NotesLog from '../shared/NotesLog';
import { getNotesForPrep, createNote, acknowledgeNote, NOTE_BODY_MAX } from '../../api/prepNotesApi';

// Adapter mapping the generic NotesLog contract onto prepNotesApi. Module-scope
// so its identity stays stable across renders.
const prepNotesAdapter = {
  getNotes: (prepId) => getNotesForPrep(prepId),
  createNote: ({ itemId, ...rest }) => createNote({ prepRequestId: itemId, ...rest }),
  acknowledgeNote: (noteId) => acknowledgeNote(noteId),
};

export default function PrepNotes({ prepId, currentUser, currentRole = null, refreshSignal = 0 }) {
  return (
    <NotesLog
      itemId={prepId}
      api={prepNotesAdapter}
      title="Notes"
      currentUser={currentUser}
      currentRole={currentRole}
      refreshSignal={refreshSignal}
      maxChars={NOTE_BODY_MAX}
    />
  );
}
